class HarbakioskMessage {
    constructor(message) {
        this.data = message.data;
        this.type = message.type;
    }
}

export default HarbakioskMessage;
